import { CopyIcon, PencilIcon, PinIcon, PinOffIcon, Trash2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import {
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'

import type { AgentItemActions } from './sidebar-item-actions.interface'

interface SidebarAgentActionsMenuProps {
  agentId: string

  isPinned?: boolean

  actions: AgentItemActions
}

export const SidebarAgentActionsMenu = ({
  agentId,
  isPinned = false,
  actions,
}: SidebarAgentActionsMenuProps): ReactNode => (
  <DropdownMenuContent side="right" align="start" className="w-48">
    <DropdownMenuGroup>
      <DropdownMenuItem onClick={() => actions.onMakeCopy(agentId)}>
        <CopyIcon />
        Make a copy
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => actions.onPin(agentId)}>
        {isPinned ? (
          <>
            <PinOffIcon />
            Unpin
          </>
        ) : (
          <>
            <PinIcon />
            Pin
          </>
        )}
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => actions.onRename(agentId)}>
        <PencilIcon />
        Rename
      </DropdownMenuItem>
    </DropdownMenuGroup>
    <DropdownMenuSeparator />
    <DropdownMenuItem variant="destructive" onClick={() => actions.onDelete(agentId)}>
      <Trash2Icon />
      Delete agent
    </DropdownMenuItem>
  </DropdownMenuContent>
)
